

































import Vue from "vue";

export default Vue.extend({
  
  data() {
    return {
      durations: [
        {
          value: 30
        },
        {
          value: 60
        },
        {
          value: 90
        },
        {
          value: 120
        }
      ],
      defaultResolutionIndex: 3,
      presets: [
        {
          title: '4K - 3840x2160',
          width: 3840,
          height: 2160,
          bitrate: 30
        },
        {
          title: '2.5K - 2560x1440',
          width: 2560,
          height: 1440,
          bitrate: 18
        },
        {
          title: '2K - 2048x1152',
          width: 2048,
          height: 1152,
          bitrate: 18
        },
        {
          title: '1080p - 1920x1080',
          width: 1920,
          height: 1080,
          bitrate: 8
        },
        {
          title: '720p - 1280x720',
          width: 1280,
          height: 720,
          bitrate: 3
        }
      ]
    };
  },
  created() {},
  methods:
  {
    setResolution(event)
    {      
      const resolution = this.presets[event.target.value];
      window.console.log(JSON.stringify(resolution));
      this.$store.commit('sequence/setWidth', resolution.width)
      this.$store.commit('sequence/setHeight', resolution.height)
      this.$store.commit('sequence/setBitRate', resolution.bitrate)
    },
    setBitRate(event)
    {
      this.$store.commit('sequence/setBitRate', event.target.value)
    },
    setFrameRate(event)
    {
      this.$store.commit('sequence/setFrameRate', event.target.value)
    },
    setDuration(event)
    {
      const duration = this.durations[event.target.value];
      
      window.console.log(JSON.stringify({duration, event}));
      this.$store.commit('sequence/setVideoDurationSecs', duration.value)
    }
  }
});
